import React from 'react';

import config from 'configs/app';

import css from './empty.module.css';

interface Props {
  text: React.ReactNode;
  className?: string;
}

/** An empty list, NirmalX style: a glass card with a slow pulse instead of a bare line of text. */
const EmptyState = ({ text, className }: Props) => (
  <div className={ `${ css.empty } ${ className ?? '' }` }>
    <div className={ css.pulse } aria-hidden="true"><span/><span/><span/></div>
    <div className={ css.title }>{ text }</div>
    <p className={ css.sub }>The { config.chain.name } is live; this fills in as activity arrives.</p>
  </div>
);

export default React.memo(EmptyState);
